export default {"src":"/_next/static/media/buy-when-ready.5b60e4c8.svg","height":594,"width":692};